const de_messages = require('./de/messages.json')

const GERMAN_STRINGS = {
  translation: de_messages
}

export default GERMAN_STRINGS
